angular.module('admin.categories.index', [
  'ui.tree',
  'security.authorization',
  'services.utility',
  'services.adminResource'
]);

angular.module('admin.categories.index').config(["$stateProvider", function($stateProvider) {
  $stateProvider
    .state('admin.categories', {
      url: '/categories',
      title: 'Manage Categories',
      views: {
        'main@': {
          template: require('./admin-categories.tpl.html'),
          controller: 'CategoriesIndexCtrl',
          // resolve: {
          //   categories: function(adminResource, $location) {
          //     return adminResource.findCategories($location.search());
          //   }
          // }
        }
      }
    });
}]);

angular.module('admin.categories.index').controller('CategoriesIndexCtrl', ['$scope', '$route', '$location', '$log', 'utility', 'adminResource', 'categories',
  function($scope, $route, $location, $log, utility, adminResource, data){
    // local var
    var deserializeData = function(data){
      $scope.items = data.items;
      $scope.pages = data.pages;
      $scope.filters = data.filters;
      $scope.categories = data.data;
    };

    var fetchCategories = function(){
      adminResource.findCategories($scope.filters).then(function(data){
        deserializeData(data);

        //update url in browser addr bar
        $location.search($scope.filters);
      }, function(e){
        $log.error(e);
      });
    };

    // $scope methods
    $scope.canSave = utility.canSave;
    $scope.filtersUpdated = function(){
      //reset pagination after filter(s) is updated
      $scope.filters.page = undefined;
      fetchCategories();
    };
    $scope.prev = function(){
      $scope.filters.page = $scope.pages.prev;
      fetchCategories();
    };
    $scope.next = function(){
      $scope.filters.page = $scope.pages.next;
      fetchCategories();
    };
    $scope.addCategory = function(){
      adminResource.addCategory($scope.add).then(function(data){
        $scope.add = {};
        if(data.success){
          $route.reload();
        }else if (data.errors && data.errors.length > 0){
          alert(data.errors[0]);
        }else {
          alert('unknown error.');
        }
      }, function(e){
        $scope.add = {};
        $log.error(e);
      });
    };

    // $scope vars
    //select elements and their associating options
    $scope.sorts = [
      {label: "id \u25B2", value: "_id"},
      {label: "id \u25BC", value: "-_id"},
      {label: "name \u25B2", value: "name"},
      {label: "name \u25BC", value: "-name"}
    ];
    $scope.limits = [
      {label: "10 Materiałów", value: 10},
      {label: "20 Materiałów", value: 20},
      {label: "50 Materiałów", value: 50},
      {label: "100 Materiałów", value: 100}
    ];

    //initialize $scope variables
    deserializeData(data);
  }
]);



// WEBPACK FOOTER //
// ./client/src/app/admin/categories/admin-categories.js